import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { NumericFormGroup, validators as V } from 'components/Forms';
import { Col, Row } from 'reactstrap';

const FieldGroup = ({ fields }) => (
  <Row className="appliance-field-group">
    {
      fields.map((c, index) => (
        <Col
          xs={12}
          lg={4}
          md={6}
          key={c.id || index}
        >
          <Field
            component={NumericFormGroup}
            label={c.label}
            placeholder={c.label}
            name={c.label}
            type={c.type || 'text'}
            required={!!c.required}
            validate={c.required ? [V.required] : []}
            tooltip={c.tooltip}
          />
        </Col>
      ))
    }
  </Row>
);

FieldGroup.propTypes = {
  fields: PropTypes.array.isRequired,
};

FieldGroup.defaultProps = {
  fields: [],
};

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js